
<div  class="outside-container " >
    <div >
        <div class="container">
          <div  class="stepper-container">
            <div class="steps">
              
              <div class="step"  [class.active]="currentStep === 1"><mat-icon style="font-size:17px; padding-top: 8px;">payments</mat-icon>Payment & Booking</div>
              <div class="step" [class.active]="currentStep === 2"> <mat-icon style="font-size: 17px;padding-top: 8px;">book</mat-icon>Insurance Detail</div>
              <!-- <div class="step" [class.active]="currentStep === 3"><mat-icon style="font-size: 17px; padding-top: 8px;">print</mat-icon>Print Detail</div> -->
            </div>
          
            <div class="step-content">
              <!-- Content for each step goes here -->
              <!-- <div *ngIf="currentStep === 1">Payment Detail Content</div>
              <div *ngIf="currentStep === 2">Booking Content</div>
              <div *ngIf="currentStep === 3">Print Detail Content</div> -->

              <div class="col-md-12">
                <form >
                  <!-- <mat-form-field>
                    <mat-label>Name</mat-label>
                    <input matInput placeholder="Last name, First name" formControlName="firstCtrl" required>
                  </mat-form-field>  -->
                  <div *ngIf="showNext && pnrData && currentStep===2" class="box-container mb-4">
              
                    <div class="container">
                      <div class="col-md-12 row" >
                        
                      <div class="col-md-4 row"> 
                       <div  class="col-md-3" ><mat-icon style="font-size: 38px;  padding: 5px 35px 35px 35px;">person</mat-icon></div>
                      <div class="col-md-9 d-flex justify-content-start"><strong>Client Name <br><span style="font-weight: 400;" class="d-flex justify-content-start">{{ pnrData?.clientName||'' }}</span></strong>
                      </div>
                      </div>
                      <div class="col-md-4 row"> 
                        <div  class="col-md-3" ><mat-icon style="font-size: 38px;  padding: 5px 35px 35px 35px;">work</mat-icon></div>
                        <div class="col-md-9  " style="text-align: left;"><strong>Trip Cart Id <br><span style="font-weight: 400;" >{{ pnrData?.orderId }}</span></strong>
                        </div>

                      </div>
                      <div class="col-md-4 row"> 

                        <div  class="col-md-3" ><mat-icon style="font-size: 38px;  padding: 5px 35px 35px 35px;">card_membership</mat-icon></div>
                        <div class="col-md-9 d-flex justify-content-start"><strong>Foreign Trip Id <br><span style="font-weight: 400;" class="d-flex justify-content-start">{{ '' }}</span></strong>
                        </div>
                      </div>


                        <!-- <p>Your PNR ({{pnrNo}}) has been successfully generated.</p> -->

                      </div> </div> 
                    
                    
                    </div>
                 
                    <div *ngIf="showNext && currentStep===2" style=" height:40vh;overflow-y: auto; overflow-x:hidden; ">
                    <div   class="box-container mb-4" >
                      <div class="card-container d-flex justify-content-start">
                        <div class="card" *ngFor="let person of data.insuranceProposalRequest.persons; let i = index">
                          <h2 class="section-title">Person {{ i + 1 }} Details</h2>
                          <div class="person-summary">
                            <p><strong>Name:</strong> {{ person.name }}</p>
                            <p><strong>DOB:</strong> {{ person.dob }}</p>
                            <p><strong>Gender:</strong> {{ person.gender }}</p>
                            <p><strong>Marital Status:</strong> {{ person.maritalStatus }}</p>
                          </div>
                      
                          <h3 class="section-subtitle">Contact Information</h3>
                          <div class="grid-2">
                            <p><strong>Email:</strong> {{ person.emailId }}</p>
                            <p><strong>Phone:</strong> {{ person.contactNo }}</p>
                            <p><strong>Address:</strong> {{ person.communicationAddress.addressLine1 }}, {{ person.communicationAddress.cityDistrict }}</p>
                            <p><strong>State:</strong> {{ person.communicationAddress.state }}</p>
                            <p><strong>PIN:</strong> {{ person.communicationAddress.pincode }}</p>
                            <p><strong>Country:</strong> {{ person.communicationAddress.country }}</p>
                          </div>
                      
                          <h3 class="section-subtitle">Nominee Info</h3>
                          <div *ngFor="let nominee of person.nominees" class="nominee-block">
                            <p><strong>Name:</strong> {{ nominee.nomineeName }}</p>
                            <p><strong>Relation:</strong> {{ nominee.nomineeRelationWithProposer }}</p>
                            <p><strong>Address:</strong> {{ nominee.nomineeAddress.addressLine1 }}, {{ nominee.nomineeAddress.cityDistrict }}</p>
                          </div>
                      
                          <h3 class="section-subtitle">Reporting Tags</h3>
                          <ul class="tags-list">
                            <li *ngFor="let tag of person.reportingTags">
                              <strong>{{ tag.displayName }}:</strong>
                              <span *ngIf="tag?.value?.includes('base64')">{{ matchbase64(tag?.value) }}</span>
                              <span *ngIf="!tag?.value?.includes('base64')">{{ tag?.value }}</span>
                            </li>
                          </ul>
                        </div>
                      
                        <div class="trip-card">
                          <h2 class="section-title">Trip Information</h2>
                          <p><strong>Plan:</strong> {{ data.insuranceProposalRequest.planName }}</p>
                          <p><strong>Destination:</strong> {{ data.insuranceProposalRequest.listOfDestination }}</p>
                          <p><strong>Dates:</strong> {{ data.insuranceProposalRequest.tripStartDate }} to {{ data.insuranceProposalRequest.tripEndDate }}</p>
                      
                          <h2 class="section-title">GST & Billing</h2>
                          <p><strong>GST No.:</strong> {{ data.gstNumber }}</p>
                          <p><strong>GST Email:</strong> {{ data.gstEmail }}</p>
                        </div>
                      </div>
                      
              </div>
              
              </div>
              
                  <div *ngIf="!showNext" class="box-container ">
              <div *ngIf="paymentPGStatus==='P'">
                <div  >
                  <div class="gif-container">
                    <img src="../../../assets/images/pendingFlight.gif" >
                </div>
                </div>
              </div>
                      <div *ngIf="paymentPGStatus!='P'" class="container">
              
                <div class="title">
                    <div class="row">
                     <div class=" col-md-2  " ><div class="pointer d-flex justify-content-start "   style="padding-left:20px;"></div></div>  
                    <div class="col-md-7 d-flex justify-content-center">Payment Details</div>
                    <div class=" col-md-3 row ">
                      <div *ngIf="userType!='AGENT'" class="d-flex justify-content-end">
                      <button class="btn btn-outline-primary btn-sm "(click)="onClickGstInfo()" >GST Information
                        <img src="assets/images/Add_24.png"></button>
                    </div>
                     </div>
                   </div>
                  </div>
                  <div *ngIf="showGstInfo" class="row mt-3" >
                    <mat-form-field class="col-md-3" appearance="outline">
                      <mat-label>GST Number</mat-label>
                      <input matInput type="text"  readonly  name="gstNumber" [ngModel]="billingEntity?.entityGST" autocomplete="off" >
  
                    </mat-form-field> 
                    <mat-form-field class="col-md-3" appearance="outline">
                      <mat-label>GST Name</mat-label>
                      <input matInput type="text" readonly  name="gstName" [ngModel]="billingEntity?.gstName" autocomplete="off" >
  
                    </mat-form-field>  
                    <mat-form-field class="col-md-3" appearance="outline">
                      <mat-label>GST Email</mat-label>
                      <input matInput type="text"  [ngModel]="billingEntity?.email" readonly name="gstEmail" autocomplete="off" >
  
                    </mat-form-field>
                    <mat-form-field class="col-md-3" appearance="outline">
                      <mat-label>GST Phone No.</mat-label>
                      <input matInput type="text" (keypress)="onlyNumberKey($event)" [ngModel]="billingEntity?.phone" readonly name="gstPhone" autocomplete="off" >
  
                    </mat-form-field>   
                  </div>
              <div class="col-md-12 row">
              <div class="payment-options col-md-9">
              
              <mat-selection-list *ngIf="orderId.userBookingContext!='P'"   [multiple]="false"  #PaymentType   (selectionChange)="OrderId()">
                <span *ngFor="let medium of orderId.paymentConfig.status" >
              <mat-list-option *ngIf="medium.isBusinessEnabled&&medium.mediumName!='PG'" isBusinessEnabled [color]="'primary'"   [value]="medium.mediumName" 
              checkboxPosition="before"><span >{{medium.mediumName}}</span>        
                      
              &nbsp;&nbsp;
              <mat-icon *ngIf="medium.mediumName!='VIRTUAL_CARD'" style="padding-top: 4px; margin-left: 10px;"  matTooltipPosition="above" (mouseenter)="GetBalance()" class="pointer"
                [matTooltip]="medium.mediumName==='DEPOSIT'?(totalBalance?.totalDepositAmount?(totalBalance?.totalDepositAmount+' INR'):'N/A'):medium.mediumName==='CREDIT'?(totalBalance?.totalCreditAmount?(totalBalance?.totalCreditAmount+' INR'):'N/A'):'N/A'"
                matTooltipHideDelay="100" matTooltipHideDelay="0">remove_red_eye</mat-icon>


              </mat-list-option>
              <!-- [disabled]="showPayNow(totalBalance?.totalDepositAmount,orderId?.priceData?.totalBookingAmount)" -->
              <button *ngIf="medium.isBusinessEnabled&&medium.mediumName==='PG'" class="stylish-button"  (click)="addAmount(totalBalance?.totalDepositAmount,orderId?.priceData?.totalBookingAmount)" >Pay Online</button>
              <div *ngIf="medium.isBusinessEnabled&&medium.mediumName!='PG'" style="font-size: 14px;">The cost of this ticket will be charged to your company account maintained with us.</div>

            </span>
              <!-- <mat-list-option    value="credit"   [color]="'primary'" checkboxPosition="before"><span (click)="openTooltip()" >Credit</span>&nbsp;&nbsp;&nbsp;&nbsp;<mat-icon style="padding-top: 4px;margin-left:10px" matTooltipPosition="above" (mouseenter)="GetBalance()"  [matTooltip]="totalBalance?.totalCreditAmount?(totalBalance?.totalCreditAmount +' INR'):'0 INR'"
                matTooltipHideDelay="100" matTooltipHideDelay="0" class="pointer">remove_red_eye</mat-icon>
              </mat-list-option>
            <span style="font-size: 14px;"> The cost of this ticket will be charged to your company account maintained with us.</span>
            <mat-list-option    value="card"   [color]="'primary'" checkboxPosition="before"><span (click)="openTooltip()" >Card</span>&nbsp;&nbsp;&nbsp;&nbsp;<mat-icon style="padding-top: 4px;margin-left:10px" matTooltipPosition="above" (mouseenter)="GetBalance()"  [matTooltip]="totalBalance?.totalCreditAmount?(totalBalance?.totalCreditAmount +' INR'):'0 INR'"
              matTooltipHideDelay="100" matTooltipHideDelay="0" class="pointer">remove_red_eye</mat-icon>
            </mat-list-option>
          <span style="font-size: 14px;"> The cost of this ticket will be charged to your company account maintained with us.</span> -->
            <div class="row">

           
              <mat-form-field *ngIf="fopType==='VIRTUAL_CARD'" class=" required col-md-12 form-group mt-2" appearance="outline">
                <mat-label>Cards</mat-label>
                <mat-select   matNativeControl name="card" [(ngModel)]="cardNo"  (selectionChange)="cardData($event)"  >
                  <mat-option *ngFor="let item of CreditData" [value]="item.maskedCardNumber"   >{{item?.maskedCardNumber}}</mat-option>
                </mat-select>
                </mat-form-field>
              </div>
              </mat-selection-list>
              
              <mat-selection-list *ngIf="orderId.userBookingContext==='P'"  [disabled]="paymentPGStatus==='P'" [multiple]="false"  #PaymentType   (selectionChange)="OrderId()">
                <span *ngFor="let medium of orderId.paymentConfig.status" >
              <mat-list-option *ngIf="medium.isPersonalEnabled"   isBusinessEnabled [color]="'primary'"   [value]="medium.mediumName" 
              checkboxPosition="before"><span >{{medium.mediumName}}</span>        
                      
              &nbsp;&nbsp;
              <mat-icon *ngIf="medium.mediumName!='VIRTUAL_CARD'" style="padding-top: 4px; margin-left: 10px;"  matTooltipPosition="above" (mouseenter)="GetBalance()" class="pointer"
                [matTooltip]="medium.mediumName==='DEPOSIT'?(totalBalance?.totalDepositAmount?(totalBalance?.totalDepositAmount+' INR'):'N/A'):medium.mediumName==='CREDIT'?(totalBalance?.totalCreditAmount?(totalBalance?.totalCreditAmount+' INR'):'N/A'):'N/A'"
                matTooltipHideDelay="100" matTooltipHideDelay="0">remove_red_eye</mat-icon>


              </mat-list-option>
              <!-- [disabled]="showPayNow(totalBalance?.totalDepositAmount,orderId?.priceData?.totalBookingAmount)" -->
              <!-- <button *ngIf="medium.isPersonalEnabled&&medium.mediumName==='PG'&&paymentPGStatus!='P'" class="stylish-button"  (click)="addAmount(totalBalance?.totalDepositAmount,orderId?.priceData?.totalBookingAmount)" >Pay Online</button>
              <button *ngIf="medium.isPersonalEnabled&&medium.mediumName==='PG'&&paymentPGStatus==='P'" class="stylish-buttons"    >Pay Online</button> -->

              <div *ngIf="medium.isPersonalEnabled&&medium.mediumName!='PG'" style="font-size: 14px;">The cost of this ticket will be charged to your company account maintained with us.</div>

            </span>
              <!-- <mat-list-option    value="credit"   [color]="'primary'" checkboxPosition="before"><span (click)="openTooltip()" >Credit</span>&nbsp;&nbsp;&nbsp;&nbsp;<mat-icon style="padding-top: 4px;margin-left:10px" matTooltipPosition="above" (mouseenter)="GetBalance()"  [matTooltip]="totalBalance?.totalCreditAmount?(totalBalance?.totalCreditAmount +' INR'):'0 INR'"
                matTooltipHideDelay="100" matTooltipHideDelay="0" class="pointer">remove_red_eye</mat-icon>
              </mat-list-option>
            <span style="font-size: 14px;"> The cost of this ticket will be charged to your company account maintained with us.</span>
            <mat-list-option    value="card"   [color]="'primary'" checkboxPosition="before"><span (click)="openTooltip()" >Card</span>&nbsp;&nbsp;&nbsp;&nbsp;<mat-icon style="padding-top: 4px;margin-left:10px" matTooltipPosition="above" (mouseenter)="GetBalance()"  [matTooltip]="totalBalance?.totalCreditAmount?(totalBalance?.totalCreditAmount +' INR'):'0 INR'"
              matTooltipHideDelay="100" matTooltipHideDelay="0" class="pointer">remove_red_eye</mat-icon>
            </mat-list-option>
          <span style="font-size: 14px;"> The cost of this ticket will be charged to your company account maintained with us.</span> -->
            <div class="row">

           
              <mat-form-field *ngIf="fopType==='VIRTUAL_CARD'" class=" required col-md-12 form-group mt-2" appearance="outline">
                <mat-label>Cards</mat-label>
                <mat-select   matNativeControl name="card" [(ngModel)]="cardNo"  (selectionChange)="cardData($event)"  >
                  <mat-option *ngFor="let item of CreditData" [value]="item.maskedCardNumber"   >{{item?.maskedCardNumber}}</mat-option>
                </mat-select>
                </mat-form-field>
              </div>
              </mat-selection-list>
              </div>
            
          

              <div class="mt-3 mb-2   col-md-3">
              
              </div>
              </div>
              
              
              </div>
              </div>
              
              <div *ngIf="!showNext" class=" mt-4 box-container ">
              <div class="container">
              
              <div  class="terms-and-conditions">
              <h4>Terms and Conditions</h4>
              <!-- <li>Meal Request, Seat Request, Special Request,Baggage Request or Frequent Flier are not guaranteed</li>
              <li>Fares and Seats are subject to availability and might not be available by the time you submit the booking request</li> -->
              <div class="d-flex justify-content-start">

              <mat-checkbox *ngIf="acceptTerm==='false'"          
                (click)="termConditions('true')" [color]="'primary'" >
                I have read and accepted the above mentioned terms and the Terms of Service</mat-checkbox>
                <mat-checkbox *ngIf="acceptFTerm==='true'"  [(ngModel)]="acceptTerm" [ngModelOptions]="{standalone: true}" (click)="termConditions('false')" [color]="'primary'" >
                  I have read and accepted the above mentioned terms and the Terms of Service</mat-checkbox>
              </div>
                
              
              </div>
              </div>
              </div>
              <mat-divider class="mt-3 mb-3"></mat-divider>
              <div  *ngIf="showNext" class="ticket-footer">
                <div class="row">
                  <div class="col-md-7 d-flex justify-content-end">
                    <!-- <button *ngIf="trip2Enable==='enable'"  mat-raised-button color="#ffffff" style="margin-right: 8px;" routerLink="/app/trip-summary">
                      <mat-icon> trip_origin</mat-icon>Go To Trip</button>
                <button  *ngIf="!disabledDownload&&trip2Enable!='enable'" mat-raised-button color="#ffffff" style="margin-right: 8px;" (click)="print()">
                  <mat-icon>print</mat-icon>Print</button>
                   <button *ngIf="!disabledDownload&&trip2Enable!='enable'"  mat-raised-button color="#ffffff" style="margin-right: 8px;" (click)="download()" >
                    <mat-icon>download</mat-icon>Download</button>
                    <button  *ngIf="disabledDownload"  mat-raised-button color="accent" style="margin-right: 2%; width: 100px;"  ><mat-spinner  diameter="30" ></mat-spinner></button> -->

                  </div>
                  <div class="col-md-5 d-flex justify-content-end">

                    <button *ngIf="trip2Enable!='enable'"   mat-raised-button color="#ffffff" style="margin-right: 8px;"(click)="backFlight()">
                      <mat-icon>arrow_back</mat-icon>Back</button>
                    </div>

                    </div>
              </div>
                  <div  class="d-flex justify-content-end">
              
              <!-- <button *ngIf="!showNext"  mat-raised-button color="accent" style="margin-right: 8px;" (click)="backClick()">
              
              <mat-icon>arrow_back</mat-icon>Back
               </button> -->

              <span *ngIf="tripEnable===false&&!showNext">
                <span *ngIf="fopType!='PG'">

                <button  *ngIf="!showSpiner && fopType==='VIRTUAL_CARD'" mat-raised-button color="accent" (click)="verifyData()" [disabled]="acceptTerm==='false'||!cardNo"> Book Insurance</button>

                <button  *ngIf="!showSpiner && fopType!='VIRTUAL_CARD'" mat-raised-button color="accent" (click)="verifyData()" [disabled]="acceptTerm==='false'"> Book Insurance</button>
</span>
                <span  *ngIf="fopType==='PG'">
                <button *ngIf="paymentPGStatus!='P'" class="stylish-button"  (click)="addAmount('',orderId?.priceData?.totalBookingAmount)" >Pay Online</button>
                <button *ngIf="paymentPGStatus==='P'" class="stylish-buttons"    >Pay Online</button>
              </span>
               <!-- <button  *ngIf="!showSpiner" mat-raised-button color="accent" (click)="booking()" [disabled]="acceptTerm==='false'"> Book Flights</button> -->
               <button  *ngIf="showSpiner"  mat-raised-button color="accent" style="margin-right: 2%; width: 100px;"  ><mat-spinner  diameter="30" ></mat-spinner></button>
              </span>
              <span *ngIf="tripEnable===true&&!showNext">
                <button   mat-raised-button color="accent" (click)="verifyData()" [disabled]="acceptTerm==='false'"> Submit Request</button>

              </span>
            
              
              <!-- <span *ngIf="!pnrData">
              <button  *ngIf="showNext && !showMore" mat-raised-button color="accent"   (click)="pnrRetreive()"> More Details</button></span>
              <button  *ngIf="showMore"  mat-raised-button color="accent" style="margin-right: 2%; width: 100px;"  ><mat-spinner  diameter="30" ></mat-spinner></button>
               -->
                  </div>
                </form>
                         
              
                          </div>
            </div>
          
            <!-- <div class="buttons">
              <button (click)="prevStep()" class="dbutton" [disabled]="currentStep === 1">Previous</button>
              <button (click)="nextStep()"  class="dbutton" [disabled]="currentStep === 3">Next</button>
            </div> -->
          </div>
        </div>
      </div>
    </div>


       
          


          <p-dialog header="Booking Details" [modal]="true" [(visible)]="verifyShow" [style]="{ width: '50rem' }">
<div *ngIf="data" >
  <div class="card-container">
    <div class="card" *ngFor="let person of data.insuranceProposalRequest.persons; let i = index">
      <h2 class="section-title">Person {{ i + 1 }} Details</h2>
      <div class="person-summary">
        <p><strong>Name:</strong> {{ person.name }}</p>
        <p><strong>DOB:</strong> {{ person.dob }}</p>
        <p><strong>Gender:</strong> {{ person.gender }}</p>
        <p><strong>Marital Status:</strong> {{ person.maritalStatus }}</p>
      </div>
  
      <h3 class="section-subtitle">Contact Information</h3>
      <div class="grid-2">
        <p><strong>Email:</strong> {{ person.emailId }}</p>
        <p><strong>Phone:</strong> {{ person.contactNo }}</p>
        <p><strong>Address:</strong> {{ person.communicationAddress.addressLine1 }}, {{ person.communicationAddress.cityDistrict }}</p>
        <p><strong>State:</strong> {{ person.communicationAddress.state }}</p>
        <p><strong>PIN:</strong> {{ person.communicationAddress.pincode }}</p>
        <p><strong>Country:</strong> {{ person.communicationAddress.country }}</p>
      </div>
  
      <h3 class="section-subtitle">Nominee Info</h3>
      <div *ngFor="let nominee of person.nominees" class="nominee-block">
        <p><strong>Name:</strong> {{ nominee.nomineeName }}</p>
        <p><strong>Relation:</strong> {{ nominee.nomineeRelationWithProposer }}</p>
        <p><strong>Address:</strong> {{ nominee.nomineeAddress.addressLine1 }}, {{ nominee.nomineeAddress.cityDistrict }}</p>
      </div>
  
      <h3 class="section-subtitle">Reporting Tags</h3>
      <ul class="tags-list">
        <li *ngFor="let tag of person.reportingTags">
          <strong>{{ tag.displayName }}:</strong>
          <span *ngIf="tag?.value?.includes('base64')">{{ matchbase64(tag?.value) }}</span>
          <span *ngIf="!tag?.value?.includes('base64')">{{ tag?.value }}</span>
        </li>
      </ul>
    </div>
  
    <div class="trip-card">
      <h2 class="section-title">Trip Information</h2>
      <p><strong>Plan:</strong> {{ data.insuranceProposalRequest.planName }}</p>
      <p><strong>Destination:</strong> {{ data.insuranceProposalRequest.listOfDestination }}</p>
      <p><strong>Dates:</strong> {{ data.insuranceProposalRequest.tripStartDate }} to {{ data.insuranceProposalRequest.tripEndDate }}</p>
  
      <h2 class="section-title">GST & Billing</h2>
      <p><strong>GST No.:</strong> {{ data.gstNumber }}</p>
      <p><strong>GST Email:</strong> {{ data.gstEmail }}</p>
    </div>
  </div>
  
          </div>
            
           
            
          <ng-template pTemplate="footer">
            <div class="flex justify-content-end gap-2 mt-3">
              
              <p-button label="Cancel" severity="secondary" (click)="verifyShow = false" />
              &nbsp;
              <p-button *ngIf="tripEnable===false" label="BOOK" (click)="booking();verifyShow = false" />
              <p-button *ngIf="tripEnable===true" label="Submit" (click)="submitRequest()" routerLink="/app/trip-summary"  />

          </div>
          </ng-template>
        </p-dialog>


        <p-dialog   [modal]="true" [maximizable]="true" [(visible)]="ShowDuplicateBookings" [style]="{ width: '80%' }">
          <ng-template pTemplate="header">
           <h4 style="color: red; ">Duplicate Booking</h4> 
          </ng-template>
          
        <div class="table-container">
          <div *ngFor="let sector of getKeys(duplicateBookingList)">
            <h3 class="mt-2">{{ sector }}</h3>
            <table class="styled-tables">
              <thead>
                <tr>
                  <th><span class="marginleft">Passenger Type</span></th>
                  <th><span class="marginleft">First Name</span></th>
                  <th><span class="marginleft">Last Name</span></th>
                  <th  *ngIf="userType==='AGENT'||userType==='CORPORATE'"><span class="marginleft">Cart UUID </span></th>
                  <th><span class="marginleft">PNR Number</span></th>
                  <th><span class="marginleft">Ticket Number</span></th>
                  <th><span class="marginleft">First Departure Time</span></th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let flight of duplicateBookingList[sector]">
                  <td ><span class="marginleft">{{ flight.passengerType }} </span></td>
                  <td ><span class="marginleft">{{ flight.firstName }}</span></td>
                  <td ><span class="marginleft">{{ flight.lastName }}</span></td>
                  <td  *ngIf="userType==='AGENT'||userType==='CORPORATE'"><span class="marginleft"  style="color: rgb(0, 115, 255);cursor: pointer;" (click)="onModifyClick(flight.cartUuid)">{{ flight.cartUuid }}</span></td>
                  <td > <span class="marginleft">{{ flight.pnrNumber || 'N/A' }}</span></td>
                  <td ><span class="marginleft">{{ flight.ticketNumber || 'N/A' }}</span></td>
                  <td ><span class="marginleft">{{ flight.firstDepartureTime || 'N/A' }}</span></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <ng-template pTemplate="footer">
          <div class="flex justify-content-end gap-2 mt-3">
            
            <!-- <p-button label="Cancel" severity="secondary" (click)="ShowDuplicateBookings = false" />
            &nbsp; -->
            <p-button  label="Accept"  />&nbsp;
            <p-button  label="Back to Search"    />

        </div>
        
        </ng-template>
      </p-dialog>
            
            

        
           
